
import { Component, Prop, Vue } from 'vue-property-decorator'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import ManageNoticeMessageLinkPanel from '@/components/organisms/manage/ManageNoticeMessageLinkPanel.vue'
import NoticeMessagePanel from '@/components/organisms/NoticeMessagePanel.vue'
import { NoticeMessageData } from '@/models/NoticeMessage'

/**
 * お知らせ詳細(管理)
 */
@Component({
  components: {
    ManageSidemenuLayout,
    ManageNoticeMessageLinkPanel,
    NoticeMessagePanel,
  },
})
export default class ManageNoticeDetail extends Vue {
  /** 塾管理権限の画面か否か */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** システム管理権限の画面か否か */
  @Prop({ default: false })
  private isAdmin!: boolean

  /** 編集可能フラグ */
  @Prop({ default: false })
  private isEditable!: boolean

  /** 戻るボタン押下時の処理 */
  @Prop()
  private eventClickBackButton!: () => void

  /** 編集ボタン押下時の処理 */
  @Prop()
  private eventClickEditButton!: () => void

  /** 削除ボタン押下時の処理 */
  @Prop()
  private eventClickDeleteButton!: () => Promise<void>

  /** メッセージ情報 */
  @Prop()
  private message!: NoticeMessageData
}
